import PlansSection from 'components/CardsSection/PlansSection';
import React, { Component } from 'react'
import Config from 'Config'
import { getPlansByCategoryID, getSubscribableCategories, getTrialConfiguration } from 'services/SellerSubscription';
import SellerStripeForm from 'components/SellerStripeForm/SellerStripeForm';
import { loadStripe } from '@stripe/stripe-js';
import SellerSearch from 'components/SellerSearch/SellerSearch';
import { Button, Dimmer, Form, Grid, Loader, Message, Select } from 'semantic-ui-react';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import PaymentCard from 'components/PaymentCard/PaymentCard';
import { addSellerSubscription, getDiscount, getPaymentIntent, getSellerPaymentMethods } from 'services/Seller';
import './AddSubscription.less'
import ErrorBox from 'components/ErrorBox/ErrorBox';

export class AddCommissionOnlySubscription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSeller: {},
            plans: [],
            categories: [],
            selectedPlan: {},
            category: {},
            isCardFormVisible: true,
            error: '',
            paymentMethods: [],
            card: null,
            stripe: null,
            selectedPaymentMethod: {},
            isLoading: false,
            isSuccessMessageShown: false,
            promo: '',
            invalidPromo: false,
            discount: null,
            verifiedPromo: null,
            trialConfiguration: {},
        }
    }

    componentDidMount() {
        loadStripe(Config.stripe.key).then(res => this.setState({ stripe: res }));
        getTrialConfiguration().then(res => {
            this.setState({ trialConfiguration: res.data })
        })
    }

    onSellerChange = (seller) => {
        this.setState({ selectedSeller: seller, paymentMethods: [], categories: [], selectedPlan: {}, category: {}, discount: null, promo: '', invalidPromo: false, verifiedPromo: null, error: "" });
        if (seller.sellerID) {
            getSubscribableCategories(seller.sellerID).then(res => {
                this.setState({ categories: res.data.map(c => ({ name: c.name, text: c.name, value: c.categoryID })) })
            })
            getSellerPaymentMethods(seller.sellerID).then(res => {
                if (res.data && res.data.length) {
                    this.setState({ selectedPaymentMethod: res.data[0], isCardFormVisible: false, paymentMethods: res.data })
                }
                else {
                    this.setState({ selectedPaymentMethod: {}, paymentMethods: [], isCardFormVisible: true })
                }
            })
        }
    }

    onCardFormToggle = (e, value) => {
        e.preventDefault();
        this.setState({
            error: '',
            isCardFormVisible: value
        })
    }

    onCategoryChange = (e, { value }) => {
        this.setState({ plans: [], selectedPlan: {} });
        getPlansByCategoryID(value).then(res => {
            if (res.data && res.data.length) {
                this.setState({
                    plans: res.data.filter(p => {
                        if (p.plan.trialDays) {
                            return this.state.trialConfiguration.allowTrialPlansOnMuntazim && p.plan.requiresPaymentMethod && p.plan.isActive && p.plan.commissionOnly
                        } else {
                            return p.plan.isActive && p.plan.commissionOnly;
                        }
                    }),
                    category: this.state.categories.find(c => c.value == value)
                })
            }
        })
    }

    showLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        this.setState({ isLoading: true })
    }

    hideLoader = () => {
        document.body.style.overflowY = 'unset'
        this.setState({ isLoading: false })
    }

    onSubmit = async () => {
        try {
            this.showLoader()
            this.setState({ error: '' })
            let pymtMethod = this.state.selectedPaymentMethod;
            if (this.state.isCardFormVisible) {
                if (!this.state.card) {
                    this.setState({ error: 'Invalid card details.' })
                    return;
                }
                // payment method creation
                const paymentMethodRes = await this.state.stripe.createPaymentMethod({
                    type: 'card',
                    card: this.state.card
                });

                if (paymentMethodRes.error) {
                    this.setState({ error: paymentMethodRes.error.message })
                    return;
                }
                pymtMethod = { ...paymentMethodRes.paymentMethod, customer: this.state.selectedPaymentMethod.customer };
            }
            const paymentRes = await getPaymentIntent(this.state.selectedSeller.sellerID, { planID: this.state.selectedPlan.planID, promo: this.state.verifiedPromo, customerID: pymtMethod.customer }, true)
            const paymentConfirmation = await this.state.stripe.confirmCardPayment(paymentRes.data.intent.client_secret, {
                payment_method: pymtMethod.id,
                setup_future_usage: 'off_session'
            });

            if (paymentConfirmation.error) {
                this.setState({ error: paymentConfirmation.error.message });
            } else {
                const sellerRes = await addSellerSubscription(this.state.selectedSeller.sellerID, {
                    paymentIntentID: paymentRes.data.intent.id,
                    isNewPaymentMethod: this.state.isCardFormVisible,
                    planID: this.state.selectedPlan.planID
                });
                if (sellerRes.resStatus == 200) {
                    //reset fields
                    this.showSuccessMessage();
                    this.onSellerChange(this.state.selectedSeller);
                } else {
                    this.setState({ error: 'Unable to complete subscription.' })
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            this.hideLoader();
        }
    }

    showSuccessMessage = () => {
        this.setState({ isSuccessMessageShown: true });
        setTimeout(() => {
            this.setState({ isSuccessMessageShown: false });
        }, 4000);
    }

    verifyPromo = async (e) => {
        if (e) e.preventDefault();
        if (!this.state.promo) return;
        const discountRes = await getDiscount(this.state.promo, this.state.selectedSeller.sellerID);
        if (discountRes.resStatus == 200) {
            this.setState({ invalidPromo: false, discount: discountRes.data, verifiedPromo: this.state.promo })
        } else {
            this.setState({ invalidPromo: true, discount: null })
        }
    }

    getInvoiceTotal = () => {
        const { discount, selectedPlan } = this.state;
        const discountAmount = discount ? discount.amount || discount.percentage * selectedPlan.price / 100 : 0;
        return Math.ceil(selectedPlan.price - discountAmount);
    }

    removeDiscount = (e) => {
        e.preventDefault();
        this.setState({ discount: null, promo: '' });
    }

    render() {
        const { categories, plans, selectedSeller, stripe, category, selectedPlan, isLoading, error, discount, promo, invalidPromo } = this.state;
        return stripe ? <div className='add-subscription-container'>
            {isLoading ? <Dimmer active>
                <Loader indeterminate size='massive' />
            </Dimmer> : ''}
            <SellerSearch onSellerChange={this.onSellerChange} />
            {selectedSeller.sellerID ? <Form>
                <Form.Group widths="equal">
                    <Form.Field
                        control={Select}
                        label={<h3>Select Category</h3>}
                        options={categories}
                        placeholder="Select category"
                        onChange={this.onCategoryChange}
                        value={category.value}
                        className='add-subscription-category-inp'
                    />
                </Form.Group>
            </Form> : ''}
            {this.state.isSuccessMessageShown ?
                <Grid.Row>
                    <Grid.Column width={16}><Message positive>
                        <p>Added seller subscription Successfully!</p>
                    </Message>  </Grid.Column>
                </Grid.Row> : ''}
            {category.value ? <div className='add-subscription-plans-selection'>
                <div className='add-subscription-plans-selection-header'> Select Plan</div>
                <PlansSection
                    setSelectedPlan={(selectedPlan) => this.setState({ selectedPlan })}
                    selectedPlan={selectedPlan}
                    plans={plans}
                />
            </div> : ''}
            {selectedPlan.planID ? <>
                <div className='add-subscription-pmt-method-selection'>
                    {this.state.isCardFormVisible ? <div className='add-subscription-card-new'>
                        <Elements stripe={this.state.stripe}>
                            <ElementsConsumer>
                                {({ stripe, elements }) => (
                                    <SellerStripeForm onExistingCardsClick={(e) => this.onCardFormToggle(e, false)} areCardsExists={this.state.paymentMethods.length} onChange={({ card }) => this.setState({ card: card })} stripe={stripe} elements={elements} />
                                )}
                            </ElementsConsumer>
                        </Elements>
                    </div>
                        : <div>
                            <div className='add-subscription-existing-card-header'>
                                Existing Cards
                                <div className='add-subscription-card-btn-container'>
                                    <button className='add-subscription-card-btn' onClick={(e) => this.onCardFormToggle(e, true)}><span>+</span> Add New Card </button>
                                </div>
                            </div>
                            {this.state.paymentMethods.map(pm =>
                                <div className='add-subscription-card-container' onClick={() => this.setState({ selectedPaymentMethod: pm })}><PaymentCard {...pm.card} isSelected={this.state.selectedPaymentMethod.id == pm.id} /></div>
                            )}
                        </div>}
                </div>
            </> : ''}

            {error ? <div className='subscription-container-error'>
                <ErrorBox message={error} />
            </div> : ''}
            {selectedPlan.planID ? <Button className='add-subscription-submit' onClick={this.onSubmit} disabled={!category.value}>Subscribe '{selectedSeller.name}' to '{category.text}' {selectedPlan.planName}
                Plan {discount ? <span className='line-through'>${Number(selectedPlan.price)} {' '}</span> : ''} <span>${this.getInvoiceTotal()}</span> </Button> : ''}
        </div> : ''
    }
}

export default AddCommissionOnlySubscription